import ButtonOutlined from '@tmh-website/ui/ButtonOutlined';
import styled from 'styled-components';

export const AdjustedButtonOutlined = styled(ButtonOutlined)<{ $hideOnMobile: boolean }>`
  margin-left: ${({ theme }) => theme.gap.xSmall};
  ${({ $hideOnMobile, theme }) =>
    $hideOnMobile &&
    `
    @media (${theme.breakpoint.sm.down}) {
      display: none;
    }
  `}
`;
